import { computed } from 'vue'

/**
 * Dev/staging/prod host classifier — the production hostname check that
 * gates LearningPlayer's env label and its dev-only query-param cheats
 * (?l1=1 / ?pod=1 / ?podview=1). The in-app preview buttons that shared it
 * went with the floating bug button (job #161, 2026-09-25).
 */
export const envLabel = computed<'DEV' | 'STAGING' | null>(() => {
  if (typeof window === 'undefined') return null
  const host = window.location.hostname
  const isProduction = host === 'saysomethingin.app'
    || host === 'www.saysomethingin.app'
    || host === 'app.saysomethingin.com'
  if (isProduction) return null
  if (host.startsWith('staging.') || host.includes('-staging')) return 'STAGING'
  return 'DEV'
})
